import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Dashboard from "./pages/Dashboard/Dashboard.js";
import Profile from "./pages/Profile/profile.js";
import Properties from "./pages/Properties/Properties.js";
import Tenants from "./pages/Tenants/Tenants.js";
import TenantDetails from "./pages/Tenants/TenantDetails.js";
import Layout from "./components/Layout/Layout.js";
import PrivateRoute from "./components/PrivateRoute";
import Login from "./components/Auth/Login.js";
import PropertyShowDetails from "./pages/Properties/PropertyShowDetails.js";
import PropertyUnits from "./pages/Properties/PropertyUnits.js";
import PublicRentalApplication from "./pages/Applications/PublicRentalApplication";
import Applications from "./pages/Applications/Applications";
import ApplicationDetails from "./pages/Applications/ApplicationDetails";
import Users from "./pages/Users/Users";
import UserDetails from "./pages/Users/UserDetails";
function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public pages - no layout wrapper */}
          <Route path="/login" element={<Login />} />
          <Route path="/apply/:propertyId" element={<PublicRentalApplication />} />

          {/* Protected routes - with layout */}
          <Route
            path="/*"
            element={
              <Layout>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/profile"
                    element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/users"
                    element={
                      <PrivateRoute>
                        <Users />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/users/:id"
                    element={
                      <PrivateRoute>
                        <UserDetails />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/dashboard"
                    element={
                      <PrivateRoute>
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/properties"
                    element={
                      <PrivateRoute>
                        <Properties />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/tenants"
                    element={
                      <PrivateRoute>
                        <Tenants />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/tenants/:id"
                    element={
                      <PrivateRoute>
                        <TenantDetails />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/applications"
                    element={
                      <PrivateRoute>
                        <Applications />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/applications/:id"
                    element={
                      <PrivateRoute>
                        <ApplicationDetails />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/properties/propertyDetails/:id"
                    element={
                      <PrivateRoute>
                        <PropertyShowDetails />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/properties/:id/units"
                    element={
                      <PrivateRoute>
                        <PropertyUnits />
                      </PrivateRoute>
                    }
                  />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
